/*
saikrishna 11/04/2022 2700430604 Added BasicInfo Form
Sohel 11/08/2022 2700430604 Integrated Save API
Sohel 11/08/2022 2700430604 Prepopulate initialValues
Sohel 11/08/2022 2700430604 Payload Changes
Lalitha 11/09/2022 2700430604 Added Prepopulate in existing TriggerCode
Lalitha 11/09/2022 2700430604 Added required lable and its validation in Add Trigger Search
Sohel 11/09/2022 2700430604 Added Field List Code
Sohel 11/14/2022 2700430604 Save API Payload Changes
Sohel 11/18/2022 2700430604 Event Type dropdown Added Valuecode
Ravi 2700430604 Added stepper tabs  toast messages
saikrishna 11/25/2022 2700430604 Added SaveAlert
saikrishna 11/29/2022 2699823790 Removed the event type dropdown codes in triggers and triggers group
Rajesh 11/29/2022 2700430604 primary account and underscore validation
Lalitha 30/11/2022 2700430604  Added validation on code
Sohel 12/01/2022 2700430604 Added Override Type in payload.
Sai maheshwar 12/04/2022 2700430604 added unsaved changes alert
Poornima 12/08/2022 2700430604 success message fixed
Saikrishna 12/09/2022 2700430604 save and stay in page functionality added.
Raghu 12/12/2022 2700430604 Button Responsive Alignment Fixes
Sohel 12/13/2022 2700430604 conditionally hide Save Button
Akhila 12/15/2022 2700430604 Added Role based access
Ashraf 12/15/2022 2700430604 Fixed Role based access
Sohel 12/16/2022 2700430604 removed Field List Code in Payload
Ashraf 12/20/2022 2700430604 fixed user role access
dilip 01/04/2023 2700430604 Removed mode field
Saikrishna 01/05/2023 2700430604 change the filter download toaster message
Lalitha 01/10/2023 2700430604  fixed download configuration issue
Saikrishna 02/13/2023 2700430604 added clientcode multiselected checkbox field
Suresh Peddavoora 02/14/2022 2700430604 Fixed Multiselect label Alignment issue
Sohel 02/15/2023 2700430604 Fixed Client Code Populate Issue
Prakash 02/17/2023 2700430604 Added class for Multiselect Label Component.
Prakash 02/20/2023 2700430604 Added class for Multiselect Label Component.
Raghu 02/22/2023 2700430604 new UI buttons change
Dilip 02/22/2023 2700430604 added download usage configuration
Raghu 02/24/2023 2700430604 new UI changes
Raghu 02/24/2023 2700430604 check box fixes
Raghu 02/28/2023 2700430604 fixed alignment issue
Raghu 02/28/2023 2700430604 fixed alignment issue
sohel 03/06/2023 2700430604 Added validation message for existing value
Sohel 03/13/2023 2700430604 Added Last Step in payload
Sohel 03/16/2023 2700430604 Fixed Stepper Step Issue
Suresh Peddavoora 03/23/2023 2700430604 Fixed textfield label shrink issue
Raghu 04/05/2023 2700430604 added new classname for textfields
Prakash 04/06/2023 3225736869  fixed button issue
Ravi  04/19/2023 3225736869  modified client code dropDownData data
Sohel 05/08/2023 3225736869 Fixed Event Type Validation Issue and Prepopulate issue
Akhila 06/21/2023 3225736869 conditionally disable save and finish button on submission
sohel 12/11/2023 3225736869  Added validation for TriggerCode and Trigger Description in Triggers Maintenance
*/
import React, {useContext, useEffect, useState} from 'react';
import {Formik} from 'formik';
import * as Yup from 'yup';
import {
  TextField,
  FormHelperText,
  Button,
  MenuItem,
  FormControl,
  Checkbox,
} from '@material-ui/core';
import {ThemeContext} from '../../../../themes/ThemeProvider';
import {getOptions} from '../../../../util/GetDropDownOptions';
import {EVENT_ACTION} from '../../../../constants/Lookup';
import {useDispatch, useSelector} from 'react-redux';
import {
  fetchDispositionCodes,
  fetchEventTactic,
  postEventTactic,
  ResetMessage as resetMessage,
  fetchAllTriggerCode,
} from '../../../../redux/reducers/EventTactics/EventTactics';
import PageLoader from '../../../../components/PageLoader';
import {ErrorSnackbar} from './../../../../components/CustomSnackBar/index';
import {SuccessSnackbar} from './../../../../components/CustomSnackBar/index';
import {getObject} from './../../../../util/GetDropdownObject';
import SelectTabContextProvider from '../../../../components/SelectTabContext/SelectTabContext';
import GuiAutoComplete from '../../../../components/FormComponents/GuiAutoComplete';
import GuiTextField from '../../../../components/FormComponents/GuiTextField';
import CheckBoxIcon from '@material-ui/icons/CheckBox';
import CheckBoxOutlineBlankIcon from '@material-ui/icons/CheckBoxOutlineBlank';
import {resetPrintUsageData} from '../../../../redux/reducers/printUsage';
import {submissionStart} from '../../../../redux/reducers/CommonActions/commonActions';
const icon = <CheckBoxOutlineBlankIcon fontSize="small" />;
const seedOnlyOptions = [
  {key: 'Y', value: 'Yes'},
  {key: 'N', value: 'No'},
];

const BasicInfo = ({
  handleBack,
  activeStep,
  handleNext,
  steps,
  stepSuccessMsg,
  setStepSuccessMsg,
  handleTabChange,
  handleDirty,
  rowSelected,
  saveRef
}) => {
  const {
    addEventTacticStatus,
    eventTacticData,
    errorMsg,
    successMsg,
    isLoading,
    dispositionDropDown,
    triggerId,
    allTriggerCode,
    downloadSuccessMsg,
  } = useSelector(({addEventTactic}) => addEventTactic);
  const {
    isLoading: printUsageIsLoading,
    successMsg: printUsageSuccessMsg,
    errorMsg: printUsageErrorMsg,
  } = useSelector(({printusage}) => printusage);
  const {enabledSubmission} = useSelector(({commonActions}) => commonActions);
  const [codePopover, setCodePopover] = useState(false);
  const [triggerCodesData, setTriggerCodesData] = useState();
  const {roleData} = useSelector(({role}) => role);
  const roleDataDisable = roleData?.window?.['Triggers Maintenance']?.TM;
  const {clientCodeDropdownData} = useSelector(({addTriggerGroup}) => addTriggerGroup);
  const {setSaveTab} =
    useContext(SelectTabContextProvider);
  const getObjects = (option, options) => {
    let label = {};
    options &&
      options.length > 0 &&
      options.forEach((item) => {
        if (item?.value === option || item?.key === option) {
          label = item;
        }
      });
    return label;
  };
  const getClientCodes = (user, clientCodeData) => {
    return clientCodeData?.filter((i) => user?.includes(i?.clientNumber));
  };
  const initialVal = {
    code: eventTacticData?.code ? eventTacticData?.code : '',
    description: eventTacticData?.description ? eventTacticData?.description : '',
    seedOnly: eventTacticData?.seedOnly ?
      getObjects(eventTacticData?.seedOnly, seedOnlyOptions) :
      '',
    // mode: eventTacticData?.mode ? getObjects(eventTacticData?.mode, modeOptions) : "",
    event:
      eventTacticData && eventTacticData?.event ?
        getObject(eventTacticData.event, EVENT_ACTION, dispositionDropDown) :
        '',
    user:
      eventTacticData?.clientCode?.length > 0 ?
        getClientCodes(eventTacticData?.clientCode, clientCodeDropdownData) :
        [],
  };

  const dispatch = useDispatch();
  const {reusableInputStyles} = useContext(ThemeContext);
  const classes = reusableInputStyles();
  const checkTriggerCodeExist = (value) => {
    if (allTriggerCode && allTriggerCode?.length > 0 && value) {
      const ar = [];
      allTriggerCode.filter((i) => {
        if (
          i?.code?.toUpperCase()?.trim() === value?.toUpperCase()?.trim() &&
          i?.isActive === 'Y'
        ) {
          ar.push(i);
        }
      });
      return ar.length > 0;
    } else {
      return false;
    }
  };
  const checkTriggerAlreadyCodeExist = (value) => {
    if (allTriggerCode && allTriggerCode?.length > 0 && value) {
      const ar = [];
      allTriggerCode.filter((i) => {
        if (
          i?.code?.toUpperCase()?.trim() === value?.toUpperCase()?.trim() &&
          i?.isActive === 'N'
        ) {
          ar.push(i);
        }
      });
      return ar.length > 0;
    } else {
      return false;
    }
  };
  const validationSchema = Yup.object().shape({
    event: Yup.mixed().test('Event', 'Event is required', (value) => {
      if (!value?.valueCode) {
        return false;
      } else {
        return true;
      }
    }),
    seedOnly: Yup.mixed().test('seed Only', 'Primary Account is required', (value) => {
      if (!value?.value) {
        return false;
      } else {
        return true;
      }
    }),
    description: Yup.string()
      .required('Trigger Description is required'),
    code: eventTacticData?.code ?
      null :
      Yup.string()
        .required('Trigger Name is required')
        .test('code', 'Trigger Name already exist', (value) => !checkTriggerCodeExist(value))
        .test(
          'code',
          'Trigger Name has already been used in the past',
          (value) => !checkTriggerAlreadyCodeExist(value),
        ),
  });
  const handleSubmit = (values) => {
    dispatch(submissionStart());
    const clientCode = values?.user?.length > 0 ? values?.user?.map((el) => el?.clientNumber) : [];
    const passValues = {
      code: values?.code,
      id: eventTacticData?.id ? eventTacticData?.id : 0,
      description: values.description ? values.description : '',
      mode: values?.mode?.value ? values?.mode?.value : '',
      ruleGroupCode: eventTacticData?.ruleGroupCode ? eventTacticData?.ruleGroupCode : '',
      seedOnly: values?.seedOnly?.key ? values?.seedOnly?.key : '',
      deletedIds: [0],
      event: values?.event?.valueCode || '',
      isDraft: eventTacticData?.isDraft ? eventTacticData?.isDraft : 'Y',
      actions: eventTacticData?.actions ? eventTacticData?.actions : [],
      name: '',
      ruleGroupId: eventTacticData?.ruleGroupId ? eventTacticData?.ruleGroupId : 0,
      triggerOwner: '',
      type: '',
      version: '',
      versionNumber: 0,
      overrideType: 'TRIGGER',
      clientCode: clientCode,
      lastStep: eventTacticData?.isDraft === 'N' ? eventTacticData?.lastStep : 1,
    };
    dispatch(postEventTactic(passValues));
  };
  useEffect(() => {
    if (addEventTacticStatus === 200 && successMsg) {
      setTimeout(() => {
        dispatch(resetMessage());
        !saveRef.current && handleNext('0');
      }, 1000);
    }
  }, [addEventTacticStatus, successMsg]);

  useEffect(() => {
    if (downloadSuccessMsg) {
      setTimeout(() => {
        dispatch(resetMessage());
      }, 1500);
    }
  }, [downloadSuccessMsg]);
  useEffect(() => {
    if (printUsageSuccessMsg || printUsageErrorMsg) {
      setTimeout(() => {
        dispatch(resetPrintUsageData());
      }, 3000);
    }
  }, [printUsageSuccessMsg, printUsageErrorMsg]);

  useEffect(() => {
    if (errorMsg || successMsg) {
      if (successMsg === 'Triggers Downloaded Successfully') {
        setStepSuccessMsg(successMsg);
      } else if (successMsg) {
        activeStep === 0 && setStepSuccessMsg(`${steps[0]} Added/Modified Successfully`);
      }
      setTimeout(() => {
        dispatch(resetMessage());
        setStepSuccessMsg('');
      }, 1000);
    }
  }, [errorMsg, successMsg]);
  useEffect(() => {
    dispatch(fetchDispositionCodes());
    dispatch(fetchAllTriggerCode());
    setSaveTab(false);
  }, []);
  useEffect(() => {
    if (triggerId) {
      dispatch(fetchEventTactic(triggerId));
    }
  }, [triggerId]);
  window.onclick = function() {
    setCodePopover(false);
  };
  const getTriggerCodesData = () => {
    if (allTriggerCode && allTriggerCode?.length > 0) {
      return allTriggerCode?.filter((i) => String(i.code?.toUpperCase())?.startsWith(triggerCodesData?.toUpperCase()));
    } else {
      return [];
    }
  };
  return (
    <>
      <Formik
        onSubmit={(values) => handleSubmit(values)}
        initialValues={initialVal}
        validationSchema={validationSchema}
        enableReinitialize
      >
        {(props) => {
          const {
            values,
            errors,
            touched,
            handleBlur,
            handleChange,
            handleSubmit,
            setFieldValue,
            dirty,
          } = props;
          handleDirty && handleDirty(dirty);
          return (
            <form autoComplete="off" noValidate onSubmit={handleSubmit}>
              <div className="form-row standard-field-textfields new-standard-textfields mt-2">
                <div className={'col-sm-6 col-md-4 col-xl-3 form-group'}>
                  <GuiAutoComplete
                    classes={{
                      popper: classes.popper,
                      option: classes.option,
                    }}
                    name="event"
                    id="event"
                    size="small"
                    value={values.event}
                    options={getOptions(EVENT_ACTION, dispositionDropDown)}
                    getOptionLabel={(option) => {
                      return option && option.value ?
                        option.valueCode === null ?
                          option.value :
                          option.value :
                        '';
                    }}
                    onChange={(e, value) => {
                      handleChange(e);
                      setFieldValue('event', value);
                    }}
                    renderInput={(params) => (
                      <div className="select-field">
                        <GuiTextField
                          className={` ${classes.labelName}`}
                          {...params}
                          variant="outlined"
                          touched={touched.event}
                          error={touched.event && errors.event}
                          margin="dense"
                          required
                          // InputLabelProps={{
                          //   shrink: true,
                          // }}
                          label="Event"
                          placeholder="Select Event"
                        />
                      </div>
                    )}
                  />
                  <FormHelperText style={{color: 'red'}}>
                    {touched.event && errors?.event && errors.event}
                  </FormHelperText>
                </div>
                <div className="col-sm-6 col-md-4 col-xl-3 form-group">
                  <TextField
                    className={` ${classes.labelName}`}
                    margin="dense"
                    variant="outlined"
                    placeholder={`Enter Trigger Name`}
                    label="Trigger Name"
                    // InputLabelProps={{
                    //   shrink: true,
                    // }}
                    name="code"
                    required
                    inputProps={{maxLength: 25}}
                    disabled={Boolean(eventTacticData?.code)}
                    value={values?.code}
                    onChange={(e) => {
                      handleChange(e);
                      setFieldValue('code', e.target.value);
                      if (e.target.value) {
                        setCodePopover(true);
                        setTriggerCodesData(e.target.value);
                      } else if (e.target.value === '') {
                        setCodePopover(false);
                      }
                    }}
                    onBlur={handleBlur}
                    fullWidth
                    touched={touched.code}
                    error={Boolean(touched.code && errors.code)}
                  />
                  <FormHelperText>{touched.code && errors?.code && errors.code}</FormHelperText>
                  <div className="windowcode-popover Add-trigger-group-popover">
                    {codePopover &&
                      getTriggerCodesData()?.map((data, i) => (
                        <MenuItem fullWidth key={i}>
                          {data?.code}
                        </MenuItem>
                      ))}
                  </div>
                </div>
                <div className="col-sm-6 col-md-4 col-xl-3 form-group">
                  <TextField
                    className={` ${classes.labelName}`}
                    margin="dense"
                    variant="outlined"
                    placeholder={`Enter Trigger Description`}
                    label="Trigger Description"
                    // InputLabelProps={{
                    //   shrink: true,
                    // }}
                    name="description"
                    required
                    value={values.description}
                    onChange={handleChange}
                    onBlur={handleBlur}
                    fullWidth
                    inputProps={{maxLength: 100}}
                    touched={touched.description}
                    error={Boolean(touched.description && errors.description)}
                  />
                  <FormHelperText>
                    {touched.description && errors?.description && errors.description}
                  </FormHelperText>
                </div>
                <div className="col-sm-6 col-md-4 col-xl-3 form-group">
                  <GuiAutoComplete
                    classes={{
                      popper: classes.popper,
                      option: classes.option,
                    }}
                    name="seedOnly"
                    id="seedOnly"
                    size="small"
                    options={seedOnlyOptions}
                    required
                    value={values.seedOnly}
                    getOptionLabel={(option) => {
                      return option && option.value;
                    }}
                    onChange={(e, value) => {
                      handleChange(e);
                      setFieldValue('seedOnly', value);
                    }}
                    renderInput={(params) => (
                      <div className="select-field">
                        <GuiTextField
                          {...params}
                          className={` ${classes.labelName}`}
                          variant="outlined"
                          margin="dense"
                          // InputLabelProps={{ shrink: true }}
                          label="Primary Account"
                          placeholder="Select Primary Account"
                          required
                          error={touched.seedOnly && errors.seedOnly}
                        />
                      </div>
                    )}
                  />
                  <FormHelperText>
                    {touched.seedOnly && errors.seedOnly && errors.seedOnly}
                  </FormHelperText>
                </div>
                <div
                  className={`col-sm-6 col-md-8 col-lg-4 col-xl-3 form-group autocomplete-field ${
                    values?.user?.length > 2 && `autocomplete-checkbox`
                  }`}
                >
                  <FormControl margin="dense" variant="outlined" fullWidth>
                    <GuiAutoComplete
                      name={'user'}
                      id={'user'}
                      size="small"
                      limitTags={1}
                      classes={{
                        option: classes.option,
                        listbox: classes.listBox,
                      }}
                      disableCloseOnSelect
                      getOptionSelected={(option, value) =>
                        option?.clientNumber === value?.clientNumber
                      }
                      value={values?.user?.length > 0 ? values?.user : []}
                      multiple
                      onChange={(e, value) => {
                        handleChange(e);
                        setFieldValue('user', value);
                      }}
                      options={clientCodeDropdownData || []}
                      autoHighlight
                      renderOption={(option, {selected}) => {
                        return (
                          <React.Fragment>
                            <>
                              <Checkbox
                                icon={icon}
                                checkedIcon={
                                  <CheckBoxIcon fontSize="small" className="selectcheckBox" />
                                }
                                checked={selected}
                              />
                            </>
                            {/* {option?.clientNumber} - {option?.clientName} */}
                            {option?.clientName}
                          </React.Fragment>
                        );
                      }}
                      getOptionLabel={(option) => {
                        // return option?.clientNumber + " - " + option?.clientName;
                        return option?.clientName;
                      }}
                      renderInput={(params) => (
                        <div className="select-field">
                          <GuiTextField
                            {...params}
                            variant="outlined"
                            className={` autocomplete-multiselect-label ${classes.labelName}`}
                            margin="dense"
                            touched={touched}
                            error={touched?.user && errors?.user}
                            // InputLabelProps={{ shrink: true }}
                            label={'Client Code'}
                            placeholder={`Select Client Code`}
                            inputProps={{
                              ...params.inputProps,
                              autoComplete: 'off', // disable autocomplete and autofill
                            }}
                          />
                        </div>
                      )}
                    />
                  </FormControl>
                  <FormHelperText variant="outlined">
                    {touched?.user && errors?.user ? errors.user : ''}
                  </FormHelperText>
                </div>
              </div>
              <div className="new-standard-textfields d-flex justify-content-center align-items-center disabled-button">
                <Button
                  variant="outlined"
                  disabled={activeStep === 0}
                  onClick={handleBack}
                  className={`reset-btn mr-1 ${classes.buttonRoot}`}
                >
                  Back
                </Button>
                {/* {eventTacticData?.isDraft === "N" && ( */}
                <Button
                  variant="outlined"
                  type="submit"
                  className={`search-btn ml-1 mr-1 ${classes.buttonRoot}`}
                  disabled={
                    (eventTacticData?.code && roleDataDisable?.edit === false && rowSelected) ||
                    enabledSubmission
                  }
                  onClick={() => {
                    saveRef.current = true;
                    handleDirty(false, 'fixed');
                  }}
                >
                  Save
                </Button>
                {/* )} */}
                <Button
                  variant="outlined"
                  type="submit"
                  className={`search-btn ml-1 ${classes.buttonRoot}`}
                  disabled={
                    (eventTacticData?.code && roleDataDisable?.edit === false && rowSelected) ||
                    enabledSubmission
                  }
                  onClick={() => {
                    saveRef.current = false;
                  }}
                >
                  Save & Next
                </Button>
              </div>
            </form>
          );
        }}
      </Formik>
      {(isLoading || printUsageIsLoading) && <PageLoader />}
      {(errorMsg || printUsageErrorMsg) && (
        <ErrorSnackbar errorMsg={errorMsg || printUsageErrorMsg} />
      )}
      {(stepSuccessMsg || downloadSuccessMsg || printUsageSuccessMsg) && (
        <SuccessSnackbar
          successMsg={stepSuccessMsg || printUsageSuccessMsg || printUsageErrorMsg}
        />
      )}
    </>
  );
};
export default BasicInfo;
